import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch, useSelector } from "react-redux";
import { deleteHardwareDescription, fetchHardwareDescriptions } from "../../../../store/slices/hardwareDescriptionSlice";
import { fetchHardware } from "../../../../store/slices/hardwareSlice";
import { useCurrencySymbol } from "../../../../utils/currencyUtils";
import CommaConvert from "../../../../utils/CommaConvert";
import { getAllAssemblyInventory } from "../../../../store/slices/assemblyInventorySlice";

const ProjectAssignOpTask = ({ row, hardwarePartsOp, setHardwarePartsOp, matchedPerson, isViewOnly = false }) => {

  const dispatch = useDispatch()
  const currency = useCurrencySymbol();
  const USAComma = CommaConvert();

  // const hardwareData = useSelector((state) => state.hardware.data);
  const { inventory } = useSelector((state) => state.assemblyInventory);

  useEffect(() => {
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchHardware());
    dispatch(getAllAssemblyInventory());

  }, [dispatch]);

  const [fetchedHardwareData, setfetchedHardwareData] = useState([]);

  useEffect(() => {
    const toTokens = (value) => {
      if (value == null) return [];
      if (Array.isArray(value)) {
        return value.flatMap((item) => toTokens(item));
      }
      if (typeof value === "object") {
        return [
          ...toTokens(value?._id),
          ...toTokens(value?.id),
          ...toTokens(value?.value),
          ...toTokens(value?.groupid),
          ...toTokens(value?.groupId),
          ...toTokens(value?.newGroupName),
          ...toTokens(value?.groupname),
          ...toTokens(value?.groupName),
          ...toTokens(value?.name),
        ];
      }
      const token = String(value).trim().toLowerCase();
      return token ? [token] : [];
    };

    const employeeGroupIds = Array.isArray(matchedPerson?.EmpGroups)
      ? matchedPerson.EmpGroups.flatMap((group) => toTokens(group))
      : [];

    const fallbackGroupTokens = [
      ...toTokens(row?.groupid),
      ...toTokens(row?.groupId),
      ...toTokens(row?.group),
      ...toTokens(row?.lead?.groupid),
      ...toTokens(row?.lead?.groupId),
      ...toTokens(row?.AssignedGroup),
    ];

    const filteredInventory =
      employeeGroupIds.length > 0
        ? (inventory || []).filter((item) => {
            const inventoryGroupValues = [
              ...toTokens(item?.groupid),
              ...toTokens(item?.groupId),
              ...toTokens(item?.group),
            ];
            return inventoryGroupValues.some((value) =>
              employeeGroupIds.includes(value)
            );
          })
        : fallbackGroupTokens.length > 0
        ? (inventory || []).filter((item) => {
            const inventoryGroupValues = [
              ...toTokens(item?.groupid),
              ...toTokens(item?.groupId),
              ...toTokens(item?.group),
            ];
            return inventoryGroupValues.some((value) =>
              fallbackGroupTokens.includes(value)
            );
          })
        : [];
    
    const newhardwareRows = filteredInventory?.map((hardware) => ({
      _id: hardware._id,
      assemblepartdescription: hardware.assembly || "",
      partnumber: hardware.partnumber || "",
      unitprice: hardware.unitprice || "",
    })) ?? [];
    setfetchedHardwareData(newhardwareRows)
  }, [inventory, matchedPerson, row]);

  const handleAddHardware = () => {
    if (isViewOnly) return;
    if (hardwarePartsOp.length >= 15) return;
    setHardwarePartsOp([
      ...hardwarePartsOp,
      {
        assemblepartdescription: "",
        partno: "",
        quantity: "",
        unitprice: "",
        totalprice: "",
      },
    ]);
  };

  const handleRemoveHardware = () => {
    if (isViewOnly) return;
    const newHardware = [...hardwarePartsOp];
    newHardware.pop();
    setHardwarePartsOp(newHardware);
    // }
  };

  const handlehardwareInputChange = (index, key, value) => {
    if (isViewOnly) return;
    const updated = [...hardwarePartsOp];
    if (key === "assemblepartdescription") {
      const selectedPart = fetchedHardwareData?.find(
        (item) => item.assemblepartdescription === value
      );
      if (selectedPart) {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: selectedPart.assemblepartdescription,
          partno: selectedPart.partnumber,
          unitprice: selectedPart.unitprice.toString(),
          totalprice:
            updated[index].quantity && updated[index].quantity !== ""
              ? (selectedPart.unitprice * Number(updated[index].quantity)).toFixed(2)
              : "",
        };
      } else {
        updated[index] = {
          ...updated[index],
          assemblepartdescription: value,
          partno: "",
          unitprice: "",
          totalprice: "",
        };
      }
    } else if (key === "quantity") {
      const quantity = Number(value);
      const unitprice = Number(updated[index].unitprice || 0);

      updated[index] = {
        ...updated[index],
        quantity: value,
        totalprice:
          !isNaN(quantity) && quantity !== 0
            ? (unitprice * quantity).toFixed(2)
            : "0.00",
      };
    } else {
      updated[index][key] = value;
    }
    setHardwarePartsOp(updated);

  };

  const handleClick = () => {
    if (isViewOnly) return;
    if (hardwarePartsOp.length > 0) {
      const lastItem = hardwarePartsOp[hardwarePartsOp.length - 1];
      dispatch(deleteHardwareDescription(lastItem?._id))
    }
  };

  return (

    <div
      className="mainhardwarekdiv w-full"
    // ref={mainHardwareDivRef}
    >
      <div className="w-fullrounded-lg h-full justify-center pb-1">
        {/* Table Header */}
        <div className="flex flex-col w-full">
          <div className="w-full flex flex-col">
            <div className="head flex text-center bg-blue-500 text-white text-xs">
              <div className=" border w-[10%] p-1 break-words whitespace-normal">Sr.No</div>
              <div className=" border w-[25%] text-[11px] p-1 break-words whitespace-normal">
                Part Name
              </div>
              <div className=" border w-[13%] text-[11px] break-words whitespace-normal p-1">Part No</div>
              <div className=" border w-[17%] text-[11px] break-words whitespace-normal p-1">Quantity</div>
              <div className=" border w-[15%] text-[11px] break-words whitespace-normal p-1">Unit Price ({currency})</div>
              <div className=" border w-[20%] text-[11px] break-words whitespace-normal p-1">Total Price ({currency})</div>
            </div>
            <div className="head flex text-center bg-blue-500  text-white text-[11px]">
                <div className=" border w-[10%] p-1 break-all whitespace-normal"></div>
                <div className=" border w-[25%] pt-1  break-all whitespace-normal">
                  Total
                </div>
                <div className=" border w-[13%] break-all whitespace-normal  p-1">
                  {" "}
                </div>
                <div className=" border w-[17%] break-all whitespace-normal p-1"></div>
                <div className=" border w-[15%] break-all whitespace-normal p-1">
                  {" "}
                </div>
                <div className=" border w-[20%] break-all whitespace-normal p-1">
                  {USAComma(
                    hardwarePartsOp?.reduce((sum, item) => {
                      return sum + Number(item.totalprice);
                    }, 0)
                  )}
                </div>
              </div>
          </div>
        </div>

        <div className="w-full">
          {hardwarePartsOp.map((row, index) => (
            <React.Fragment key={index}>
              <div className="flex items-center text-center w-full text-[11px]">
                <div className="w-full">
                  <div className="flex">
                    <div className="flex justify-center items-center border w-[10%] p-1">{index + 1}</div>
                    {/* Description Select */}
                    <div className=" border w-[25%] [11px]">
                      <select
                        name="assemblepartdescription"
                        value={row.assemblepartdescription || ""}
                        disabled={isViewOnly}
                        onChange={(e) =>
                          handlehardwareInputChange(
                            index,
                            "assemblepartdescription",
                            e.target.value
                          )
                        }
                        className={`outline-none border-none text-center w-full h-full [11px] ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : "bg-gray-100"}`}
                      >
                        <option value="" disabled hidden>
                          {row.assemblepartdescription ? "" : "Select Option"}
                        </option>
                        {fetchedHardwareData?.map((option) => {
                          const isAlreadySelected = hardwarePartsOp.some(
                            (row, i) =>
                              row.assemblepartdescription ===
                              option.assemblepartdescription && i !== index
                          );
                          if (isAlreadySelected) return null;

                          return (
                            <option
                              key={option._id}
                              value={option.assemblepartdescription}
                            >
                              {option.assemblepartdescription}
                            </option>
                          );
                        })}
                      </select>
                    </div>

                    {/* Part Number */}
                    <div className="flex justify-center items-center border w-[13%] p-1 text-[11px]">
                      {row.partno || " "}
                    </div>

                    {/* Quantity Input */}
                    <div className=" border w-[17%] p-1 text-[11px]">
                      <input
                        type="text"
                        placeholder="Enter quantity"
                        value={row.quantity || ""}
                        disabled={isViewOnly}
                        onChange={(e) => {
                          let value = e.target.value;

                          if (/^\d*\.?\d{0,3}$/.test(value) || value === "") {
                            handlehardwareInputChange(index, "quantity", value);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (
                            !(
                              (e.key >= "0" && e.key <= "9") ||
                              e.key === "." ||
                              e.key === "Backspace" ||
                              e.key === "Delete" ||
                              e.key === "ArrowLeft" ||
                              e.key === "ArrowRight" ||
                              e.key === "Tab"
                            )
                          ) {
                            e.preventDefault();
                          }
                        }}
                        className={`outline-none border-none text-center w-full h-full ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                      />

                    </div>

                    {/* Unit Price */}
                    <div className="flex justify-center items-center border p-1 w-[15%] text-[11px]">
                      {USAComma(row.unitprice) || " "}
                    </div>

                    <div className=" border p-1 w-[20%] text-[11px]">
                      {USAComma(row.totalprice) || ""}
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}

          {matchedPerson?.projecttracktaskStatus !== "submit" && (
            <>
              {matchedPerson?.operationaction === "accept" && (


                <div className="flex justify-between px-2 pt-1">
                  <button
                    className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                    onClick={handleAddHardware}
                    disabled={isViewOnly || hardwarePartsOp.length >= 15}
                  >
                    <AddIcon />
                  </button>
                  <button
                    className={`shadow-xl rounded-md p-1 ${isViewOnly ? "bg-[#e5e7eb] text-[#9ca3af] cursor-not-allowed" : ""}`}
                    disabled={isViewOnly}
                    onClick={() => {
                      handleRemoveHardware()
                      handleClick()
                    }}
                  >
                    <RemoveIcon />
                  </button>
                </div>
              )}
            </>
          )}

        </div>


      </div>
    </div>
  );
};

export default ProjectAssignOpTask;
